<template>
  <a-layout-header class="nav">
    <div class="logo clear-fix">
      <img src="~image/common/logo.png" alt="" srcset="" class="logoIcon">
      <div class="logoText">RTU后台管理</div>
    </div>
    <a-menu
      @select="handleSubMenu"
      mode="horizontal"
      :selected-keys="selectedKey"
      class="nav-menu"
      :overflowedIndicator="overflowedIndicator"
    >
      <template v-for="item in routerListNew">
        <a-menu-item :key="'/RMS'+item.url">
          <a-icon :type="item.icon" />
          <span>{{item.name}}</span>
        </a-menu-item>
      </template>
      <template v-for="item in routerList">
        <a-menu-item :key="item.path" v-if="!item.hidden">
            <a-icon :type="item.meta.icon" />
            <span>{{item.meta.title}}</span>
        </a-menu-item>
      </template>
    </a-menu>

  </a-layout-header>
</template>

<script>
import cache from 'utils/cache'
export default {
  components: {
  },
  data() {
    return {
      // 自定义溢出「…」，避免被当成菜单项 key 跳转
      overflowedIndicator: '···'
    }
  },
  created() {
  },
  mounted() {

  },
  updated() {

  },
  watch: {
  },
  methods: {
    /**
    * 逻辑区
    */
    handleSubMenu(item) {
      const key = item && item.key
      // Ant Design 横向菜单溢出指示器会触发 select，key 类似 Menu-overflowed-indicator
      if (!key || this.isOverflowMenuKey(key)) {
        return
      }
      this.$router.push({
        path: key
      })
    },
    isOverflowMenuKey(key) {
      const k = String(key)
      return k.indexOf('overflowed') !== -1
        || k.indexOf('OVERFLOWED') !== -1
        || k === '···'
        || k === '...'
    },
    /**
    * 接口区
    */


  },
  computed: {
    selectedKey() {
      const path = this.$route.path
      const menus = cache.get("device-menus") || []
      // 动态菜单：不区分大小写匹配 item.url
      const matchNew = menus.find(item => item.url.toLowerCase() === path.toLowerCase())
      if (matchNew) {
        return ['/RMS' + matchNew.url]
      }
      // 静态路由：匹配自身 path 或子路由，找到父级菜单 key
      const staticRoutes = this.$router.options.routes
      for (const route of staticRoutes) {
        if (route.hidden) continue
        if (route.path === path) return [route.path]
        if (route.children && route.children.some(c => c.path === path)) {
          return [route.path]
        }
      }
      return [path]
    },
    routerList() {
      return this.$router.options.routes
    },
    routerListNew(){
      const menus = cache.get("device-menus");
      console.log('菜单列表:', menus)
      return menus || [];
    }

  }
}
</script>

<style lang='scss' scoped>
  .logo {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    padding: 0 20px;
    margin-right: 12px;
    white-space: nowrap;
    .logoIcon {
      width: 35px;
      height: 33px;
      margin-right: 10px;
      float: none;
      display: block;
    }
    .logoText {
      line-height: 1;
      font-size: 18px;
      float: none;
      color: #FFFFFF;
    }
  }
  .nav {
    height: $layout-nav-height;
    width: 100%;
    line-height: $layout-nav-height;
    padding: 0;
    display: flex;
    align-items: center;
    background-color: $layout-nav-bgc;
    overflow: hidden;
  }
  .nav-menu {
    flex: 1;
    min-width: 0;
    height: 100%;
    background: transparent;
    border-bottom: none;
    line-height: $layout-nav-height;
  }
  .nav-menu ::v-deep .ant-menu-overflow {
    display: flex;
    align-items: center;
  }
  .nav-menu ::v-deep .ant-menu-item {
    color: #fff;
    line-height: $layout-nav-height;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 18px;
    border-bottom: 2px solid transparent;
  }
  .nav-menu ::v-deep .ant-menu-item-selected {
    background-color: rgba(255, 255, 255, 0.12);
    color: #fff;
    border-bottom-color: #fff;
  }
  .nav-menu ::v-deep .ant-menu-item:hover {
    color: #fff;
    border-bottom-color: rgba(255, 255, 255, 0.6);
  }
  .ant-menu {
    background-color: transparent;
    color: #FFF;
  }
  .ant-menu-inline .ant-menu-item:not(:last-child),
  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline,
  .ant-menu-inline .ant-menu-item::after,
  .ant-menu-vertical .ant-menu-submenu,
  .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left,
  .ant-menu-submenu-open, .ant-menu-submenu-active {
    margin-bottom: 0;
    margin-top: 0;
    border-right: none;
    color: #FFF;
    padding: 0;
  }
</style>
